import { render, staticRenderFns } from "./MoreContent.vue?vue&type=template&id=4fe04b36&scoped=true"
import script from "./MoreContent.vue?vue&type=script&lang=js"
export * from "./MoreContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe04b36",
  null
  
)

export default component.exports